import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from '@nextui-org/react'
import { ReactNode } from 'react'

import { Text } from '@/components/common/UI'

interface AlertModalProps {
    isOpen: boolean
    onOpenChange: (isOpen: boolean) => void
    title: string
    message: string | ReactNode
    buttonText?: string
    buttonColor?:
        | 'default'
        | 'primary'
        | 'secondary'
        | 'success'
        | 'warning'
        | 'danger'
    icon?: ReactNode
    backdrop?: 'transparent' | 'opaque' | 'blur'
    placement?: 'auto' | 'top' | 'bottom' | 'center'
}

export function AlertModal({
    isOpen,
    onOpenChange,
    title,
    message,
    buttonText = 'Aceptar',
    buttonColor = 'primary',
    icon,
    backdrop = 'opaque',
    placement = 'center'
}: AlertModalProps) {
    const handleClose = () => {
        onOpenChange(false)
    }

    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            backdrop={backdrop}
            placement={placement}
            isDismissable={false}
            hideCloseButton={true}
        >
            <ModalContent>
                <ModalHeader>
                    <div className="flex items-center gap-2">
                        {icon}
                        <span>{title}</span>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {typeof message === 'string' ? (
                        <Text text={message} />
                    ) : (
                        message
                    )}
                </ModalBody>
                <ModalFooter className="flex justify-center">
                    <Button
                        color={buttonColor}
                        onPress={handleClose}
                    >
                        {buttonText}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
